import { render, staticRenderFns } from "./bank-accounts.vue?vue&type=template&id=c41274b6"
import script from "./bank-accounts.vue?vue&type=script&lang=js"
export * from "./bank-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports